module.exports = __webpack_public_path__ + "static/img/sou-w-m@2x.89b9e06c.png";